<template>
  <v-carousel
    :show-arrows="false"
    class="pa-0 ma-0 carousel"
    height="740px"
  >
    <v-carousel-item
      v-for="(image, i) in assets.gallery"
      :key="i"
      class="pa-0 ma-0"
    >
      <v-sheet
        height="100%"
        tile
      >
        <v-row
          class="fill-height"
          align="center"
          justify="center"
        >
          <div class="display-3">

            <v-img
              :lazy-src="image.filename"
              :src="image.filename"
            ></v-img>
          </div>
        </v-row>
      </v-sheet>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
export default {
  name: 'Slider',
  props: {
    assets: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="scss">
.v-carousel__controls {
  background: transparent;
  display: flex;
  justify-content: flex-end;

  .v-carousel__controls__item {
    width: 25px;
    height: 25px;
    transition: 0.5s;

    &.v-item--active {
      .v-btn__content {
        background: #ee396c;
        transition: 0.5s;
      }
    }

    &:hover {
      .v-btn__content {
        background: #ee396c;
      }
    }

    .v-icon {
      opacity: 0;
    }

    .v-btn__content {
      background: #fff;
      border-radius: 50%;
      transition: 0.5s;
    }
  }
}
</style>
